import jwtDecode from 'jwt-decode';
import type { AppRole } from './permissions';

// Sessions created before this version assigned systemadmin to every login.
// Require those sessions to log in again instead of reusing the old role.
export const AUTHORIZATION_VERSION = 1;

export function sessionUserInfo(data: any, accessToken: string, username = '') {
  let claims: any = {};
  try {
    claims = jwtDecode(accessToken);
  } catch {
    // Tokens without role claims never imply administrator access.
  }
  const user = data?.user ?? data?.userInfo ?? data ?? {};
  const { access, refresh, access_token, refresh_token, ...profile } = user;
  // The backend supplies the application role in the access token.
  // Ignore role-like fields in the response/profile and old stored groups.
  const role: AppRole = claims.token_type === 'access' && claims.role === 'admin' ? 'admin' : 'user';
  return {
    ...profile,
    mail: user.email || user.mail || user.username || username,
    groups: role,
    ou: user.ou || '',
    appRole: role,
    authorizationVersion: AUTHORIZATION_VERSION
  };
}
